'use client';

import { useEnvContext } from '@/app/providers';

import type { ReactNode } from 'react';


export const NotProductionBoundry = ({ children }: { children: ReactNode }) => {
  const environment = useEnvContext();

  if (environment.env === 'prod' || environment.env === 'nonprod') {
    return null;
  }

  return <> {children} </>;
};
